module.exports = __webpack_public_path__ + "static/media/timothy-buck-309898-unsplash.ea57ec08.jpg";